import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Button/Button.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Center/Center.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Grid"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Grid/Grid.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["GridCol"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Grid/GridCol/GridCol.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Text/Text.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Title"] */ "/home/runner/work/web/web/node_modules/@mantine/core/esm/components/Title/Title.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/web/web/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/AIFeaturesSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/BecomeAMentorHeroWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/src/components/FeaturedMentorsSection.tsx");
